import { AuthContainer } from 'containers'

type PageHeaderProps = {
  title?: string
  description?: string
  showCompanyName?: boolean
  showSupplierName?: boolean
}

const CompanyNameDisplay = (companyName: string) => {
  return (
    <div className="flex flex-row items-center px-5 py-1 bg-gray-100 border border-gray-300 rounded-md">
      <span className="mr-2 text-lg font-semibold">Company:</span>
      <span className="mt-1 text-lg">{companyName}</span>
    </div>
  )
}

const SupplierNameDisplay = (supplierName: string) => {
  return (
    <div className="flex flex-row items-center px-5 py-1 bg-gray-100 border border-gray-300 rounded-md">
      <span className="mr-2 text-lg font-semibold">Supplier:</span>
      <span className="mt-1 text-lg">{supplierName}</span>
    </div>
  )
}

export const PageHeader = (props: PageHeaderProps) => {
  const { title = '', description, showCompanyName, showSupplierName } = props
  const { user, selectedSupplier } = AuthContainer.useContainer()

  return (
    <div className={`flex flex-col items-start justify-between ${title ? 'py-7' : ''}`}>
      <div className="flex flex-row flex-wrap w-full justify-between items-center">
        <h1 className="text-2.125">{title}</h1>
        {showCompanyName && CompanyNameDisplay(user?.supplierDetails?.supplierName ?? '-')}
        {showSupplierName && SupplierNameDisplay(selectedSupplier?.name ?? '-')}
      </div>
      {description && <div className="pt-5 text-lg font-light">{description}</div>}
    </div>
  )
}
